import { t } from 'i18next';
import z from 'zod';
import { CredentialField } from '../../../../components/credential-field';
import type { Setting } from '../../../../context/settings-context';
import { useSettings } from '../../../../context/settings-context';
import type { I18nPrefix } from '../../../../i18n/prefix';
import { useAppForm } from '../../../../lib/app-form';
import { PARTNER_DOCS_URLS } from '../../constants';
import type { PartnerModalProps } from '../../types';
import { PartnerModal, saveAction } from '../partner-modal';
import { credentialValidator, usePartnerModalSave } from './shared';

const LINNWORKS = 'features:partners.components.linnworks' satisfies I18nPrefix;

export function LinnworksModal({ isOpen, onClose }: PartnerModalProps) {
  const settings = useSettings();
  const { save, isSaving } = usePartnerModalSave(onClose);

  const hasStoredToken = !!settings.integrationLinnworksToken;

  const form = useAppForm({
    defaultValues: { token: '' },
    validators: { onSubmit: z.object({ token: credentialValidator(hasStoredToken) }) },
    onSubmit: ({ value }) => {
      const payload: Setting[] = [{ key: 'integrationLinnworks', value: true }];
      const token = value.token.trim();
      if (token) {
        payload.push({ key: 'integrationLinnworksToken', value: token });
      }
      void save(payload);
    },
  });

  return (
    <PartnerModal
      isOpen={isOpen}
      onClose={onClose}
      title="Linnworks"
      description={t(`${LINNWORKS}.description`)}
      docsUrl={PARTNER_DOCS_URLS.linnworks}
      primaryAction={saveAction(() => void form.handleSubmit(), isSaving)}
    >
      <form.Field name="token">
        {(field) => (
          <CredentialField
            label={t(`${LINNWORKS}.token_label`)}
            value={field.state.value}
            onChange={field.handleChange}
            hasStoredValue={hasStoredToken}
            error={field.state.meta.errors[0]?.message}
          />
        )}
      </form.Field>
    </PartnerModal>
  );
}
